module.exports = __webpack_public_path__ + "static/aaron_haynes-af1af62012a2f3d92f244bf92b8f3aef.jpg";